/* eslint-disable */

export var VUE_APP_BASE_API = process.env.VUE_APP_BASE_API || '';
export var VUE_APP_BAIDU_MAP_API_KEY = process.env.VUE_APP_BAIDU_MAP_API_KEY || '';
export var VUE_APP_QQ_MAP_API_KEY = process.env.VUE_APP_QQ_MAP_API_KEY || '';
export var VUE_APP_H5_PUBLISH_PATH = process.env.VUE_APP_H5_PUBLISH_PATH || '';